import React from "react";
import { Avatar } from "antd";
import AvatarS4u from '../../assets/img/AvatarS4u.png';

const MobileAvatar = ({ src }) => {
  if (!src) return null;

  const toggleSidebar = () => {
    document.dispatchEvent(new CustomEvent('toggleSidebar'));
  };

  return (
    <div 
      className="flex justify-center items-center md:hidden m-0" 
      onClick={toggleSidebar} 
      style={{ cursor: 'pointer' }}
    >
      <Avatar 
        src={src || AvatarS4u} 
        size="large"
        style={{
          width: '40px',
          height: '40px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
        }}
      />
    </div>
  );
};

export default MobileAvatar;
